import propstreamConnectLogo from 'assets/images/propstream-connect.svg';
import classNames from "classnames";
import * as moment from 'moment';
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import currencyFormat from 'utils/currency/numberToPrice';
import numberFormat from 'utils/number/format';
import downFullArrow from '../../../assets/images/account-page/down-full-arrow.svg';
import { downgradeSubscribeLeadAutomator, getPlanDetails, selectBillingDashboard, selectCardList, selectLeadAutomator, selectPlanDetails, selectUserId, trialLeadAutomator, unSubscribeLeadAutomator, upgradeSubscribeLeadAutomator } from "../../../data/user";
import CreditCardDropdown from "../components/CreditCardDropdown";
import css from '../style.scss';
import CVV99Modal from "../components/cvv99Modal";
import LeaveMessagePopup from '../modals/LeaveMessage';
import DNCPolicyModal from '../../components/DNCPolicyModal';
import { useToast } from '../../components/ToastMessage/ToastManager';
import AccountLogo from '../components/AccountLogo';

const ManageLeadAutomatorScreen = (props) => {


  const { type } = props.match.params;
  const [screenType, setscreenType] = useState(type);
  const [showCVVModal, setShowCVVModal] = useState(false);
  const userId = useSelector(selectUserId);
  const dispatch = useDispatch();
  const showToast = useToast();
  const leadAutomatorInfo = useSelector(selectLeadAutomator)?.toJS();

  const cardList = useSelector(selectCardList);
  const billingInfo = useSelector(selectBillingDashboard)

  const planDetails = useSelector(selectPlanDetails)?.toJS();

  const [selectedCard, setSelectedCard] = useState(cardList[0] || {}); // Default selected card
  const isDowngrade = leadAutomatorInfo?.selectedLead?.quantity < leadAutomatorInfo?.monitoredProperties;
  const trialEndDate = !planDetails?.usedLATrial ? moment().add(14, 'days').format('MMMM D, YYYY') : 'Today';
  const trialEndMoment = !planDetails?.usedLATrial ? moment().add(14, 'days') : moment();
  let renewalDate = billingInfo?.leadAutomatorRenews
    ? moment.utc(billingInfo?.leadAutomatorRenews)
    : moment.utc(billingInfo?.psConnectNextBillingCycleDate);
  if (renewalDate.isBefore(trialEndMoment, 'day')) {
    renewalDate = renewalDate.clone().add(1, 'month');
  }

  const handleCardChange = (selectedOption) => {
    setSelectedCard(selectedOption);
  };

  const goToManageleadAutomator = () => {
    props.history.push(`/accountnew/leadautomator`);
  }

  // const goToManageLeadAutomator = (type) => {
  //   props.history.push(`/accountnew/manageleadautomator/${type}`);
  // };

  const goToAccount = () => {
    props.history.push(`/accountnew/landing`);
  }

  const updateLeadAutomator = async ({ cardCode = "" }) => {
    const upgradePayload = {
      userId,
      planMrcId: leadAutomatorInfo?.selectedLead?.id,
      purchasePaymentMethodId: selectedCard?.paymentMethodId,
      proratedAmount: leadAutomatorInfo?.selectedLead?.prorateAmount || leadAutomatorInfo?.selectedLead?.amount,
    };
    const currentPlanMrcId = leadAutomatorInfo?.planMrcs?.find((item) => item?.quantity === leadAutomatorInfo?.monitoredProperties)?.id;
    const currentActivePlanMrcId = leadAutomatorInfo?.accountPlanMrcs?.find((item) => item?.quantity === leadAutomatorInfo?.monitoredProperties)?.id;
    const downgradePayload = {
      userId,
      currentPlanMrcId,
      downgradePlanMrcId: leadAutomatorInfo?.selectedLead?.id,
      planMrcId: currentPlanMrcId,
      approvedAmount: leadAutomatorInfo?.selectedLead?.amount,
    };
    const unsubscribePayload = {
      userId,
      planMrcId: currentActivePlanMrcId,
    };
    const trialAutomatorPayload = {
      userId,
      planMrcId: leadAutomatorInfo?.selectedLead?.id,
    };

    if (Number(leadAutomatorInfo?.selectedLead?.amount) && !cardCode) {
      setShowCVVModal(true);
      return;
    }
    try {
      let response;
      if (!planDetails?.usedLATrial) {
        if (cardCode) {
          trialAutomatorPayload.cardCode = cardCode;
        }
        response = await trialLeadAutomator(trialAutomatorPayload);
      } else if (leadAutomatorInfo?.selectedLead?.quantity > leadAutomatorInfo?.monitoredProperties) {
        if (cardCode) {
          upgradePayload.cardCode = cardCode;
        }
        response = await upgradeSubscribeLeadAutomator(upgradePayload);
      } else if (leadAutomatorInfo?.selectedLead?.quantity < leadAutomatorInfo?.monitoredProperties) {
        if (cardCode) {
          downgradePayload.cardCode = cardCode;
        }
        response = await downgradeSubscribeLeadAutomator(downgradePayload);
      } else if (!leadAutomatorInfo?.selectedLead) {
        if (cardCode) {
          unsubscribePayload.cardCode = cardCode;
        }
        response = await unSubscribeLeadAutomator(unsubscribePayload);
      }
      if (response.success) {
        console.log("Update lead automator success:", response);
        // Show different toast messages based on action type
        let toastMessage = '';
        if (!planDetails?.usedLATrial && !planDetails?.trialAvailable) {

          toastMessage = "PropStream Connect trial started successfully";
        }
        else if (!currentPlanMrcId && planDetails?.usedLATrial ) {
          toastMessage = "PropStream Connect started successfully";
        }
        else if (currentPlanMrcId && leadAutomatorInfo?.selectedLead?.quantity > leadAutomatorInfo?.monitoredProperties) {
          toastMessage = "PropStream Connect subscription upgraded successfully";
        }
        else if (leadAutomatorInfo?.selectedLead?.quantity < leadAutomatorInfo?.monitoredProperties) {
          toastMessage = "PropStream Connect subscription downgrade request submitted successfully";
        }
        else if (!leadAutomatorInfo?.selectedLead) {
          toastMessage = "Unsubscribed from PropStream Connect successfully";
        } else {
          toastMessage = "PropStream Connect started successfully";
        }

        showToast(toastMessage, "success");
        setShowCVVModal(false);
        dispatch(getPlanDetails(userId));
        goToAccount();

      } else {
        console.error(`Update lead automator failed:`, response.error);
        setShowCVVModal(false);
        showToast(response.error, "error");
        // dispatch(LeaveMessagePopup.open({
        //   title: "Error",
        //   message: response.error,
        //   yesLable: "Ok",
        //   cancelLable: null,
        //   CancelRedirect: () => null,
        //   yesRedirect: () => null
        // }))
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      setShowCVVModal(false);
      dispatch(LeaveMessagePopup.open({
        title: "Error",
        message: response.error,
        yesLable: "Ok",
        cancelLable: null,
        CancelRedirect: () => null,
        yesRedirect: () => null
      }))
    }
  }
  const openDNCPolicyModal = () => {
    dispatch(DNCPolicyModal.open())
  }


  return (
    <>
      <div className={css.clsInnerMainBody}>
        <div>
           <div className="container">
            <div className={css.clsLAReviewPaySec}>
              <div className="row justify-content-center" style={{"padding-bottom": '13rem'}}>
                <div className="col-lg-4">

                  <FromToSelectedTier
                    fromtype="MONITORED PROPERTIES"
                    fromAmount={leadAutomatorInfo?.monitoredProperties}
                    totype="MONITORED PROPERTIES"
                    toAmount={leadAutomatorInfo?.selectedLead?.quantity}
                  />

                </div>
                  <div className="col-lg-5">
                    {screenType === 'unsubscribe' ? (<ReviewConfirmUnsubscribe />) : (
                       <div className={css.clsLAReviewPayCard2}>
                       <h3 className={css.clsLAReviewHeading}>
                        <AccountLogo />
                        Review And Confirm Changes</h3>
                       <div className={css.clsLAReviewPayTimelineContainer}>
                         <div className={css.clsLAReviewPayTimeline}>
                           <div className={css.clsLATimelineItem}>
                             <div className={css.clsLATimelineDot}></div>
                             <div className={css.clsLATimelineContent}>
                               <div className={css.clsLATimelineHead}>
                                 <h4 className={css.clsLATimelineLabel}>{isDowngrade ? 'Today' : `Due ${trialEndDate}`}</h4>
                                 <h5 className={css.clsLATimelinePrice}>
                                  {currencyFormat(leadAutomatorInfo?.selectedLead?.prorateAmount)}</h5>
                               </div>
                              {isDowngrade ? (
                                <p className={css.clsLATimelineDescription}> {billingInfo?.leadAutomatorRemainingDays || null} days remaining in your current PropStream Connect plan</p>
                              ) : (<p className={css.clsLATimelineDescription}>  PropStream Connect {!planDetails?.usedLATrial ? 'trial' : 'plan'} begins. {billingInfo?.leadAutomatorRemainingDays ? `${billingInfo?.leadAutomatorRemainingDays} days until next billing cycle.` : !planDetails?.usedLATrial ?' 14 days until next billing cycle.' : ''}</p>)}
                             </div>
                           </div>

                           <div className={ isDowngrade ? css.clsLATimelineLineDowngrade : css.clsLATimelineLine }></div>

                           <div className={css.clsLATimelineItem}>
                             <div className={css.clsLATimelineDot}></div>
                             <div className={css.clsLATimelineContent}>
                               <div className={css.clsLATimelineHead}>
                                 <h4 className={css.clsLATimelineLabel}>Starting {renewalDate.format('MMMM D, YYYY')}</h4>
                                 <h5 className={css.clsLATimelinePrice}>{currencyFormat(leadAutomatorInfo?.selectedLead?.amount)}/month</h5>
                               </div>
                                {isDowngrade ? (
                                  <p className={css.clsLATimelineDescription}> New PropStream Connect plan begins</p>
                                ): ""}
                             </div>
                           </div>
                         </div>
                       </div>

                       <div className={css.pb_48}>
                         <div className={css.clsLAReviewPMCard}>
                           <h4 className={css.clsLAReviewPMCardHeading}>Payment Method</h4>
                           <CreditCardDropdown
                              tag={false}
                              options={cardList}
                              paymentMethodType={'Subscription'}
                              onChange={(selectedOption) => handleCardChange(selectedOption)}
                            />
                         </div>
                       </div>

                       <div className={css.clsLAReviewContentPara}>
                         <p className={classNames(css.clsPara, css.mb_16)}>
                           <span className={css.text_b}>Starting on {renewalDate.format('MMMM D, YYYY')} you’ll be charged {currencyFormat(leadAutomatorInfo?.selectedLead?.amount, null, { forceDecimal: true })}/month until you cancel.</span> This subscription is billed separately from other PropStream services. Prices subject to change.
                         </p>
                         <p className={css.clsPara}>
                           By selecting <span style={{ fontWeight: 700 }}>{!planDetails?.usedLATrial ? 'Start Trial' : 'Confirm Changes'}</span> you agree to our <a target="_blank" href="https://www.propstream.com/terms-of-use" className={css.terms_conditions}>Terms and Conditions.</a>
                         </p>
                       </div>
                     </div>
                    )}

                </div>


              </div>
            </div>
          </div>
        </div>

        <div className={css.clsInnerFooter}>

          <>
           <button className={classNames(css.clsBackBtn)} onClick={() => goToManageleadAutomator()}> Back to Tiers </button>
           <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnOrng)} onClick={updateLeadAutomator}>{!planDetails?.usedLATrial ? 'Start Trial' : !leadAutomatorInfo?.accountPlanMrcs?.[0]?.id ? 'Subscribe Now':'Confirm Changes'}</button>
          </>
        </div>
        {showCVVModal && <CVV99Modal
          showCVVModal={showCVVModal} cardEnding={selectedCard?.cardEnding} cvvLength={selectedCard?.cardCVVLength} handleSubmitCVV={updateLeadAutomator}
          handleCancel={() => setShowCVVModal(false)} handleClose={() => setShowCVVModal(false)}  />}
      </div>
    </>
  );
};



const FromToSelectedTier = (props) => {
  return (
    <div className={css.clsLAReviewPayCard}>
    <div className={css.clsLAReviewLeadAutoDetils}>
      <div className="d-flex align-items-center">
        <div className={css.clsLAReviewLeadAutoImg}>
          <img src={propstreamConnectLogo} alt="propstreamConnectLogo" />
        </div>
        {/* <h5 className={css.clsLAReviewLeadAutomatorTxt2}>Lead Automator</h5> */}
      </div>
    </div>
    <div className={css.clsLAReviewTier}>
      <h4 className={css.clsTxtLine1}>{props?.fromAmount > 0 ? props?.fromtype :''}</h4>
      <h4 className={css.clsTxtLine2}>{props?.fromAmount > 0 ? numberFormat(props?.fromAmount) : 'NONE'}</h4>
    </div>
    <div className="text-center">
      <ReactSVG src={downFullArrow} className={classNames(css.mb_16, css.mt_16)} />
    </div>
    <div className={css.clsLAReviewTier}>
      <h4 className={css.clsTxtLine1}>{props?.toAmount > 0 ? props?.totype : ''}</h4>
      <h4 className={css.clsTxtLine2}>{props?.toAmount > 0 ? numberFormat(props?.toAmount) : 'NONE'}</h4>
    </div>
  </div>
  )
}

const ReviewConfirmUnsubscribe = (props) => {
  const billingInfo = useSelector(selectBillingDashboard);
  return (
    <div className={css.clsLAReviewPayCard2}>
    <h3 className={css.clsLAReviewHeading}>Review And Confirm Changes</h3>
    <div className={css.clsLAReviewPayTimelineContainer}>
      <div className={css.clsLAReviewPayTimeline}>
        <div className={css.clsLATimelineItem}>
          <div className={css.clsLATimelineDot}></div>
          <div className={css.clsLATimelineContent}>
            <div className={css.clsLATimelineHead}>
              <h4 className={css.clsLATimelineLabel}>Today</h4>
            </div>
            <p className={css.clsLATimelineDescription}> {billingInfo?.leadAutomatorRemainingDays || null} days remaining in your PropStream Connect plan</p>
          </div>
        </div>

        <div className={css.clsLATimelineLine2Unsubscribe}></div>

        <div className={css.clsLATimelineItem}>
          <div className={css.clsLATimelineDot}></div>
          <div className={css.clsLATimelineContent}>
            <div className={css.clsLATimelineHead}>
              <h4 className={css.clsLATimelineLabel}>{billingInfo?.leadAutomatorRenews ? moment.utc(billingInfo?.leadAutomatorRenews).format('MMMM D, YYYY') : moment.utc(billingInfo?.psConnectNextBillingCycleDate).format('MMMM D, YYYY') }</h4>
            </div>
            <p className={css.clsLATimelineDescription}>PropStream Connect will become inactive. Resubscribe any time to restore access.</p>
          </div>
        </div>
      </div>
    </div>



    <div className={css.clsLAReviewContentPara}>

      <p className={css.clsPara}>
        By selecting <span style={{ fontWeight: 700 }}>Confirm Changes</span> you agree to our <a target="_blank" href="https://www.propstream.com/terms-of-use" className={css.terms_conditions}>Terms and Conditions.</a>
      </p>
    </div>
  </div>
  )
}


export default withRouter(ManageLeadAutomatorScreen);
